import { useState } from "react";

const About = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="about" className="py-8 text-white border-t border-gray-700">
      {/* Header with toggle */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 cursor-pointer focus:outline-none"
      >
        <h2 className="text-2xl font-bold">About</h2>
        <span
          className={`text-xl font-bold transform transition-transform duration-300`}
          style={{
            display: "inline-block",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          ﹀
        </span>
      </button>

      {/* Collapsible content */}
      {isOpen && (
        <div className="mt-4 max-w-3xl space-y-4">
          <p>Hi, we’re Bright Ripple Studios.<br /><br />
          Back in 2019, we started with a simple dream — to help people and businesses grow on social media in a way that felt authentic and stress-free.<br /><br />
          Since then, we’ve partnered with over 500 amazing clients around the globe through our social media management services, earning a 4.9/5 rating on Fiverr. Building on that journey, we’ve now introduced our AI Twin service — a new way to create content without spending hours in front of a camera, while still keeping your real voice and presence.<br /><br />
          We’re a small team of video editors, AI engineers, and digital marketers, working together to make something powerful: Content that feels like you — your style, your tone, your presence — all brought to life in a way that saves you time and energy.<br /><br />
          Bright Ripple Studios was founded by three cofounders who share the same vision of simplifying creativity and making it impactful.<br /><br />
          And because we believe creativity should create a positive impact, 2% of everything we earn goes directly toward protecting nature. It’s our small way of giving back to the planet that gives us so much.<br /><br />
          Thank you for being here — we’d love to create something amazing with you.<br />
          Bright Ripple Studios — where creativity finds its purpose.</p>
        </div>
      )}
    </section>
  );
};

export default About;
